import { RootState } from '@/store';

export const userProgramSelector = (state: RootState) => state.app.userSelectedPrograms;
export const timeoutIdSelector = (state: RootState) => state.app.settingsTimeoutId;
export const programsListWSUpdatesSelector = (state: RootState) => state.app.programsListWSUpdates;
export const selectNotificationType = (state: RootState) => state.app.notificationType;
export const progInFullScreenSelector = (state: RootState) => state.app.progIdInFullScreen;
export const selectNotifications = (state: RootState) => state.app.notifications;
export const selectHighlightedDates = (state: RootState) => state.app.highlightedDates;
